import React, { Component, Fragment } from 'react';
import {
    Alert,
    View,
    TextInput,
    Image,
    KeyboardAvoidingView,
    TouchableWithoutFeedback,
    StatusBar,
    Keyboard,
    Platform
} from 'react-native';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ButtonLoading from '../../react-component/buttonLoading';
import Text from '../../react-component/textComponent';

import { loginAuth } from '../../config/Auth';

import { Creators as userActions } from '../../store/ducks/user';
import { Creators as toastActions } from '../../store/ducks/toast';
import { Creators as pedidoSelecionadoActions } from '../../store/ducks/pedido-selecionado';

import styles from './styles';
const logo = require('../../assets/img/logo.png');

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            isLoading: false,
            error: null
        };
    }

    render() {
        const { error } = this.state;

        return (
            <Fragment>
                <StatusBar backgroundColor="#FFFFFF" barStyle="light-content" />

                <TouchableWithoutFeedback
                    onPress={() => {
                        if (Platform.OS !== 'web') Keyboard.dismiss();
                    }}
                    keyboardShouldPersistTaps="always"
                >
                    <KeyboardAvoidingView
                        behavior="padding"
                        style={styles.container}
                    >
                        <View style={styles.formContainer}>
                            <View style={styles.logoContainer}>
                                <Image
                                    resizeMode="contain"
                                    style={styles.logo}
                                    source={logo}
                                />
                            </View>
                            <TextInput
                                style={[styles.input, styles.inputUsername]}
                                autoCapitalize="none"
                                value={this.state.username}
                                onSubmitEditing={() => this.onButtonPress()}
                                onChangeText={(username) =>
                                    this.setState({ username })
                                }
                                autoCorrect={false}
                                keyboardType="email-address"
                                returnKeyType="next"
                                placeholder="Usuário"
                                placeholderTextColor="rgba(0,0,0, 1)"
                            />

                            <TextInput
                                style={[styles.input, styles.inputPassword]}
                                value={this.state.password}
                                onSubmitEditing={() => this.onButtonPress()}
                                onChangeText={(password) =>
                                    this.setState({ password })
                                }
                                placeholder="Senha"
                                returnKeyType="next"
                                placeholderTextColor="rgba(0,0,0, 1)"
                                secureTextEntry
                            />

                            {error && (
                                <Text style={styles.error}>
                                    Usuário ou senha inválidos
                                </Text>
                            )}

                            <ButtonLoading
                                label="Entrar"
                                onPress={this.onButtonPress}
                                isLoading={this.state.isLoading}
                            />
                        </View>
                    </KeyboardAvoidingView>
                </TouchableWithoutFeedback>
            </Fragment>
        );
    }

    onButtonPress = () => {
        const { username, password } = this.state;

        if (username === '' && password === '') {
            Alert.alert('Atenção', 'Usuário e senha inválidos');
            return;
        } else if (username === '') {
            Alert.alert('Atenção', 'Usuário inválido');
            return;
        } else if (password === '') {
            Alert.alert('Atenção', 'Senha inválida');
            return;
        }

        Keyboard.dismiss();

        this.onLoginAuth();
    };

    onLoginAuth = async () => {
        this.props.deselectPedido();

        const { username, password, isLoading } = this.state;
        if (isLoading) {
            return;
        }

        this.setState({ ...this.state, isLoading: true });

        try {
            const token = await loginAuth({
                username,
                password
            });

            this.props.deselectPedido();
            this.props.onLoginSuccess({ token });
        } catch (error) {
            this.setState({ ...this.state, isLoading: false, error: true });
        }
    };
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { ...userActions, ...pedidoSelecionadoActions, ...toastActions },
        dispatch
    );

export default connect(null, mapDispatchToProps)(Login);
